import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/ui/TestimonialCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
